import yup from 'src/utils/yup';
import createTypedAction from '../createTypedAction';

export const PREFIX = '@@fox/dashboard/';

/* Starts a new query from the first page, dropping what's loaded. */
export const { fetchDeviceList, FETCH_DEVICE_LIST }: any = createTypedAction(
  `${PREFIX}FETCH_DEVICE_LIST`,
  ['selectedFilters', yup.immutable().map()],
  ['sort', yup.string().required()],
  ['scope', yup.object().nullable()],
  ['countKeys', yup.array().of(yup.string())]
);

export const { fetchDeviceListNextPage, FETCH_DEVICE_LIST_NEXT_PAGE }: any = createTypedAction(
  `${PREFIX}FETCH_DEVICE_LIST_NEXT_PAGE`
);

export const { fetchDeviceListSuccess, FETCH_DEVICE_LIST_SUCCESS }: any = createTypedAction(
  `${PREFIX}FETCH_DEVICE_LIST_SUCCESS`,
  ['page', yup.object().required()]
);

export const { fetchDeviceListFailed, FETCH_DEVICE_LIST_FAILED }: any = createTypedAction(
  `${PREFIX}FETCH_DEVICE_LIST_FAILED`,
  ['err', yup.object().nullable()]
);
